import React from 'react';
import { Grid} from '@mui/material';
import {Info} from '@mui/icons-material';
import './DialogModel.css';
import * as msg from "../../utils/constants/messages";

const DialogModal = (props) => {
    let message = '';
        if(props.message) message = props.message;
        else if(props.page === 'review'){
           message = msg.ext_info;
        } else 
        message = msg.no_data;
      return(
            <Grid>
                <div style={{marginTop: "10px"}}>
                    <Info className="nodata-icon" fontSize = 'large' />
                <p style = {{fontWeight : '500',margin: 'unset', color: 'var(--text-grey)'}}>{message}</p>
                </div>
            </Grid>
        );
    
}
export default DialogModal;

